import {ComponentType, useMemo} from "react";
import {Extension} from "@/types/extenions.ts";
import {useDropExtensionMutation} from "@/store/extensions.ts";
import {useDispatch} from "@/store";
import {setCopyAdvancedSettings, setDuplicateExtension, setMovingExtension} from "@/store/extensionsPageActions.ts";
import {toast} from "sonner";
import {DocumentDuplicateIcon, Square2StackIcon, TrashIcon} from "@heroicons/react/24/outline";
import {Action} from "@/pages/extensions/helpers.ts";
import {ArrowRightLeftIcon} from "lucide-react";

type GlobalExtensionActions = Omit<Action & { icon?: ComponentType }, 'allow' | 'types'>[]

export function useGlobalExtensionActions(ext: Extension, isMain?: boolean): GlobalExtensionActions {

    const [dropExtension, dropState] = useDropExtensionMutation();
    const dispatch = useDispatch();

    function handleDuplicate() {
        dispatch(setDuplicateExtension({ext}));
    }

    function handleCopyAdvancedSettings() {
        dispatch(setCopyAdvancedSettings(ext));
    }

    function handleMoveExtension() {
        dispatch(setMovingExtension(ext))
    }

    async function handleDelete() {
        return await dropExtension(ext.id).unwrap()
            .then(() => toast.success('השלוחה נמחקה בהצלחה'))
            .catch(error => {
                toast.error(error.data.error ?? 'שגיאה: השלוחה לא נמחקה');
            })
    }

    const actions: GlobalExtensionActions = useMemo(() => [
        {
            name: 'שכפול שלוחה',
            action: 'duplicate_extension',
            description: 'action',
            call: (ext: Extension) => {
                handleDuplicate()
            },
            icon: DocumentDuplicateIcon
        },
        {
            name: 'העברת שלוחה',
            action: 'move_extension',
            description: 'action',
            disabled: isMain,
            call: (ext: Extension) => {
                handleMoveExtension()
            },
            icon: ArrowRightLeftIcon
        },
        {
            name: 'העתקת הגדרות מתקדמות',
            action: 'copy_advanced_settings',
            description: 'action',
            call: () => {
                handleCopyAdvancedSettings();
            },
            icon: Square2StackIcon
        },
        {
            name: 'מחיקה',
            action: 'delete_extension',
            description: 'action',
            disabled: isMain,
            call: async () => {
                return await handleDelete();
            },
            confirm: (ext: Extension) => ({
                title: "האם אתה בטוח שברצונך למחוק את השלוחה " + ext.name + "?",
                message: `השלוחה מכילה ${ext.count_sub_sclass} תתי שלוחות אם ברצונך להעבירם לשלוחה אחרת, עצור! ובחר בפעולה התאימה בתפריט פעולות שלוחה`,
                variant: 'danger',
                confirmText: 'מחק',
                cancelText: 'ביטול',
            }),
            icon: TrashIcon
        }
    ], [ext]);

    return actions;

}